import React  from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';
import Text, { Large, H4 } from '@dbk/ui-text';
import { SimpleNumber } from '../../components/common/number/simple-number';
import {Currency } from '../../components/common/number';
import styles from './dashboard-styles';

function TotalMarketValueView({
    messages,
    marketTotal
}){

    return(
        <div className="summaryTotal-container">
            <H4 className="summaryTotal-title margin-top-5" tabIndex={0}>
            {messages['app.dashboard.summaryData.marketValue.total.title']}
            </H4>
            <H4 className="summaryTotal-value margin-top-5" tabIndex={0}>
                <Currency
                    signBeforeNumber={false}
                    decimalStyle={styles.decimelStyle}
                    renderProps={{
                        style: styles.marketTotalNomination,
                        size: 24
                    }}
                    value={marketTotal}
                />
                {/* <SimpleNumber
                renderProps={{
                    style: styles.marketTotal,
                  }}
                minimumFractionDigits={2}
                maximumFractionDigits={2}
                value={marketTotal}/> */}
            </H4>
            <H4 className="summaryTotal-proportion margin-top-5" tabIndex={0}>
            {messages['app.dashboard.summaryData.proportion.total']}
            </H4>
        </div>
    );

}
   
TotalMarketValueView.propTypes = {
    marketTotal: PropTypes.number,
    prefCurrency: PropTypes.string,
  };
  
  
export default pure(TotalMarketValueView);